export function getBars(rates) {
    const baseBarIds = rates
        .filter((rate) => rate?.base_rate_for_bar)
        .map((rate) => rate.base_rate_for_bar)
        .sort();

    const bars = {};
    const childBars = {};
    const childBarsIds = [];
    const baseBars = [];

    rates.forEach((rate) => {
        if (baseBarIds.includes(rate.id)) {
            baseBars.push(rate);
        }
        if (rate.base_rate_for_bar) {
            if (!bars[rate.base_rate_for_bar]) {
                bars[rate.base_rate_for_bar] = [];
            }
            bars[rate.base_rate_for_bar].push(rate);

            childBars[rate.id] = rate;
            childBarsIds.push(rate.id);
        }
    });

    return { bars, childBars, childBarsIds, baseBars, baseBarIds };
}
